import React, { useEffect, useState } from 'react';
import { Sprite } from './sprite';

interface Props {
  children: React.ReactNode;
}

export const MoreButton: React.FC<Props> = ({ children }) => {
  const [active, setActive] = useState(false);

  // close menu on click outside
  useEffect(() => {
    const action = () => {
      setActive(false);
    };
    document.addEventListener('click', action);
    return () => document.removeEventListener('click', action);
  }, [setActive]);

  return (
    <div className="">
      <button
        className="absolute"
        type="button"
        onClick={event => {
          event.stopPropagation();
          setActive(!active);
        }}>
        <Sprite name="icon-more" className=" w-[24px] h-[24px]" />
      </button>
      {active && (
        <div className="absolute mt-[-50px] right-0 shadow-lg bg-white py-2 z-[1] min-w-[140px] rounded-[6px] w-[180px] mr-4">
          {children}
        </div>
      )}
    </div>
  );
};
